"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeTracking = initializeTracking;

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _GlobalEventTracker = require("@insided/shared/services/GlobalEventTracker");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _globals = _interopRequireWildcard(require("@insided/shared/utils/globals"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function fetcher(data) {
  var newEventData = Object.assign(data, {
    eventName: 'userevent',
    eventDetail: data.eventName
  });

  _publish.default.trackEvent('userevent', newEventData);
}

function initializeTracking() {
  var insidedData = {
    subfolderPrefix: (0, _globals.getSubfolderPrefix)(),
    communityId: (0, _insidedDataStorage.getInsidedData)('communityId'),
    environment: (0, _insidedDataStorage.getInsidedData)('environment'),
    language: (0, _insidedDataStorage.getInsidedData)('language'),
    locale: (0, _insidedDataStorage.getInsidedData)('locale'),
    user: (0, _insidedDataStorage.getInsidedData)('user'),
    form: (0, _insidedDataStorage.getInsidedData)('form'),
    device: (0, _insidedDataStorage.getInsidedData)('device'),
    page: (0, _insidedDataStorage.getInsidedData)('page'),
    content: (0, _insidedDataStorage.getInsidedData)('content'),
    search: (0, _insidedDataStorage.getInsidedData)('search')
  };
  var globalEventTracker = new _GlobalEventTracker.GlobalEventTracker(fetcher, (0, _globals.default)('environment') === 'development', insidedData);
  globalEventTracker.startTracking(['click', 'keydown']);
}